
  import { defineComponent } from "vue";
  
  export default defineComponent({
    name: "ShareImg",
    data() {
      return {};
    },
    props: {
      imgSrc: {
        type: String,
        required: true,
        default: ''
      }
    },
    methods: {
      closeShareImg() {
        this.$emit("close");
      },
    }
  });
  